module.exports = __webpack_public_path__ + "static/nsec-ec1c43fc4a6856cbfca704209be2290b.png";